<script>
  import RetryPage from "../../../Shared/retryPage.svelte"
  import Progress from "../../../Shared/progress.svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  /**
   * @type {string} name of the start button
   */
  export let startBtnName
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  export let activeDoc
  /**
   * @type {number} width of the progress bar
   */
  export let width
</script>

{#if activeDoc == "start"}
  <div class="mt-6 flex w-full justify-center text-center text-base text-gray-400 mobile:w-3/4 md:w-1/2">
    {#if startBtnName == "Revoke Documents"}
      <h1>To initiate the process, simply click the 'Revoke Documents' button to revoke all documents.</h1>
    {:else}
      <h1>To proceed with the procedure, press the "Resume" button to revoke the remaining documents.</h1>
    {/if}
  </div>
  <div class="mt-6">
    <button on:click type="button" class="flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] {startBtnName == 'Revoke Documents' ? 'bg-green-500 hover:bg-green-600 active:bg-green-500 disabled:bg-green-500/50' : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500 disabled:bg-blue-500/50'} px-2 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed lg:px-4">
      <span>
        <i class="fa-solid fa-circle-play" />
      </span>
      <span class="select-none">&nbsp;&nbsp;{startBtnName}&nbsp;</span>
    </button>
  </div>
{:else if activeDoc == "processing"}
  <Progress {width} content="Revoking Documents" />
{:else if activeDoc == "completed"}
  <div class="mt-12 flex w-full items-center justify-center gap-3 text-center text-3xl font-bold text-green-500 mobile:w-4/5 lg:w-3/5">
    <i class="fa-solid fa-circle-check" />
    <h1 class="text-2xl">Process Completed</h1>
  </div>
  <div class="mt-6 flex w-full justify-center text-center text-base text-gray-400 mobile:w-4/5 lg:w-3/5">
    <h1>The files have been successfully revoked, and you can view the report by clicking the button below.</h1>
  </div>
  <div class="mt-12 flex w-full justify-center gap-3">
    <button
      on:click={() => {
        dispatch("viewReport")
      }}
      type="button"
      class="normal-blue-btn disabled:text-white-200/50 disabled:cursor-not-allowed disabled:bg-blue-200/50"
    >
      <span><i class="fa-solid fa-eye" /></span>
      <span class="select-none">&nbsp;&nbsp;View&nbsp;&nbsp;Report&nbsp;</span>
    </button>
  </div>
{:else}
  <RetryPage content="A few documents encountered failures during the revokation process. Please consider retrying to proceed." />
{/if}

<style lang="postcss">
  .normal-blue-btn {
    @apply flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500;
  }
</style>
